export const TOGGLE_LANG = 'LANG::TOGGLE_LANG';

export const toggleLang = () => ({
    type: TOGGLE_LANG
});